import type {WebappCurrentUser} from '@dokia/strapi/types';

import {userGetUsersById} from '@dokia/strapi';

import {decodeJwtPayload} from './decodeJwtPayload';

export const fetchCurrentUser = async (
  accessToken: string,
): Promise<null | WebappCurrentUser> => {
  const jwtPayload = decodeJwtPayload<{strapiUserId?: string}>(accessToken);

  if (!jwtPayload?.strapiUserId) return null;

  try {
    const result = await userGetUsersById({
      path: {documentId: jwtPayload.strapiUserId},
      query: {populate: ['firm', 'roleFirm']},
    });
    if (!result.data?.data) return null;
    return result.data.data;
  } catch (error) {
    console.error('[fetchCurrentUser] caught:', error);
    return null;
  }
};
